
import React from "react";
import Navbar from "@/components/layout/Navbar";
import DashboardMetrics from "@/components/dashboard/DashboardMetrics";
import NotesPanel from "@/components/dashboard/NotesPanel";
import { Toaster } from "@/components/ui/toaster";

const Index = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <div className="mobile-container w-full py-4 sm:py-6">
        <Navbar />
        <main className="flex-1 overflow-y-auto mt-4 sm:mt-6">
          <div className="max-w-6xl mx-auto">
            <DashboardMetrics />
            <div className="grid grid-cols-1 gap-4 sm:gap-6">
              <NotesPanel />
            </div>
          </div>
        </main>
      </div>
      <Toaster />
    </div>
  );
};

export default Index;
